<template>
    <div class="container my-5">
		<span class="d-flex justify-content-end pointer mb-4 mb-md-2" @click.prevent="$router.go(-1)">{{$t('back-to-previous-page')}}</span>
		<div class="w-100 row">
			<div class="col-12 col-md-8 order-last order-md-first mx-auto">
				<div class="d-flex justify-content-between">
					<!-- <h4 class="bold">{{ $t('product-name') }}:</h4> -->
					<h4 class="mx-3 bold">{{productData?.name}}</h4>
					<router-link :to="'/all-products/' + productData?.categories[0]?.slug" class="category-color mx-3 pointer">{{ productData?.categories[0]?.name }}</router-link>
				</div>
				<div class="mx-1 my-3 v-html-p">
					<p class="ck-content" v-html="productData?.description"></p>
				</div>
				<!-- <hr> -->
				<div>
					<!-- <h4 class="bold mb-4">{{ $t('attributes') }}:</h4> -->
					<!-- <div class="d-flex flex-column flex-sm-row flex-wrap">
						<div class="attributes-block d-flex w-50" v-for="(item, index) in productData?.attributes" :key="index">
							<h6 class="bold px-2 my-2 pb-2">{{item.name}}:</h6>
							<div class="attribute-value-block v-html-p">
								<p v-html="item.value" class="mt-0"></p>
							</div>
						</div>
					</div> -->

					<!-- for multiple values -->
					<div v-if="productData" class="d-flex flex-column flex-sm-row flex-wrap">
						<div class="attributes-block d-flex flex-wrap align-items-center" v-for="(item, index) in productData?.attributes" :key="index">
							<h6 class="bold px-2 mt-2 v-html-h6">{{item.name}}:</h6>
							<div v-if="item.type === 13" class="d-flex">
								<div v-for="(element, i) in filterAttributeValues(item)" :key="i" class="d-flex align-items-center">
									<div class="mx-1" :style="{ backgroundColor: element, width: '20px', height: '20px', borderRadius: '50%', border: '1px solid grey' }"></div>
								</div>
							</div>
							<div v-else class="d-flex flex-wrap">
								<div v-for="(element, i) in fixedValues(item.value)" :key="i" class="attribute-value-block">
									<div class="v-html-p-attributes" v-html="element"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-4 order-first order-md-last mb-4 d-flex justify-content-center align-items-start">
				<img :src="productData?.primaryImage.url" alt="" class="product-image-width rounded-4 main-image-margin">
			</div>
		</div>
	</div>
</template>

<script>
import { filterAttributeValues } from '@/helpers/functions';
import { mapState } from 'vuex'
export default {
	name: 'ProductPage',
	data () {
		return {
			productData: null
		}
	},

	computed: {
		...mapState({
			products: state => state.products.products,
		}),
	},

	methods: {
		fixedValues (value) {
			if (!value) return [];
			return value.split(/[،,]/).map(val => val.trim());
		},
		filterAttributeValues
	},

	created () {
		this.$emit('loading', true)
		this.$store.dispatch('products/fetchProductBySlug', {
			slug: this.$route.params.slug
		}).then((response) => {
			this.productData = response.data
			this.$emit('loading', false)
		})
	}

}
</script>

<style lang="scss" scoped>
@import '../../scss/vars.scss';

.product-image-width {
	width: 175px;

	@media (max-width: 768px) {
		width: 200px;
	}
}

.attributes-block {
	width: 50%;
	@media (max-width: 576px) {
		width: 100%
	}

	p {
		margin-top: 3px;
	}
}

.attribute-value-block {
	border: 1px solid $primary;
	padding: 5px 8px;
	border-radius: 10px;
	margin: 3px;
	background-color: rgb(237, 237, 255);
}

.category-color {
	color: $secondary;
	text-decoration: none;

	&:hover {
		text-decoration: underline;
	}
}

.main-image-margin {
	@media (max-width: 992px) {
		margin-bottom: 25px;
	}
}

</style>

<style lang="scss">
.v-html-h6 * {
	margin-top: 0;
	margin-bottom: 0;
}

.v-html-p * {
	margin-top: 0px;
	margin-bottom: 0px;
	background-color: #FAFAFA;
}

.v-html-p-attributes * {
	background-color: transparent;
	margin-top: 0px;
	margin-bottom: 0px;
}

.ck-content table {
  border: none !important;
}

.ck-content {
	.table {
		width: 100% !important
	}
}

.ck-content td,
.ck-content th {
  border: none !important;
  text-align: right !important;
	[dir='ltr'] & {
		text-align: left !important;
	}
  vertical-align: top !important;
}

</style>